import {useCountedItemEdit} from '../useCountedItem/useCountedItemEdit'

export const useItemsInvalidEdit = (itemId, refreshTable, initialUpc, initialMkt, initialAmount) => {
    return useCountedItemEdit({
        itemId,
        initialUpc,
        initialMkt,
        initialAmount,
        refreshCallback: refreshTable
    })
}